import React from 'react'

import styled from 'styled-components'
import moment from 'moment'

import { RiPencilFill } from 'react-icons/ri'
import { FaTrashCan } from 'react-icons/fa6'

const JobExperienceListItem = ({
  id,
  jobTitle,
  companyName,
  companyLocation,
  industry,
  experienceCurrentStatus,
  workType,
  jobDescriptionHtml,
  experienceFrom,
  experienceTo,
  onEdit,
  onDelete,
}) => {
  return (
    <StyledListItem>
      <div className="list__item">
        <div className="list__item__header">
          <h5 className="list__item__header_text">{jobTitle}</h5>
          <div className="list__item__header__icons">
            <RiPencilFill
              onClick={() =>
                onEdit({
                  id,
                  jobTitle,
                  companyName,
                  companyLocation,
                  industry,
                  experienceCurrentStatus,
                  workType,
                  jobDescriptionHtml,
                  experienceFrom,
                  experienceTo,
                })
              }
            />
            <FaTrashCan onClick={() => onDelete(id)} />
          </div>
        </div>
        <div className="list__item__body">
          <div className="list__item__body__school">
            <h5>{companyName}</h5>
            {', '}
            <h5>{companyLocation}</h5>
          </div>
          <h5 className="list__item__industry">{industry}</h5>
        </div>
        <div className="list__item__body__dates">
          <h5>
            {moment(experienceFrom).format('LL')} -{' '}
            {moment(experienceTo).format('LL')}
          </h5>
        </div>
      </div>
    </StyledListItem>
  )
}

const StyledListItem = styled.div`
  h5 {
    display: inline;
    font-size: 14px;
    font-weight: 300;
  }

  .list__item {
    border: 1px solid #dfe2ec;
    border-radius: 3px;
    padding-left: 17px;
    margin: 12px 0px 8px 0px;
    cursor: pointer;

    .list__item__header {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: baseline;
      padding-top: 11px;

      .list__item__header_text {
        font-weight: 500;
        font-size: 16px;
      }

      .list__item__header__icons {
        display: flex;
        gap: 14px;
        font-size: 18px;
        margin-right: 14px;
        cursor: pointer;
      }
    }

    .list__item__body {
      display: flex;
      justify-content: space-between;

      .list__item__body__school {
        display: inline;
        font-size: 14px;
      }

      .list__item__industry {
        padding-right: 1rem;
        font-weight: 500;
        color: #00b300;
      }
    }

    .list__item__body__dates {
      padding-bottom: 0.5rem;
    }
  }
`

export default JobExperienceListItem
